import { render, staticRenderFns } from "./allComprasOrdenTrabajo.vue?vue&type=template&id=0d42b2d2&scoped=true"
import script from "./allComprasOrdenTrabajo.vue?vue&type=script&lang=js"
export * from "./allComprasOrdenTrabajo.vue?vue&type=script&lang=js"
import style0 from "./allComprasOrdenTrabajo.vue?vue&type=style&index=0&id=0d42b2d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d42b2d2",
  null
  
)

export default component.exports